import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import useFetch from "../../../hooks/useFetch";
import { userCollectionPagesList } from "../../../services/userCollectionService";

// const sanitizeContent = (htmlString) => {
//   try {
//     const parser = new DOMParser();
//     const doc = parser.parseFromString(htmlString, "text/html");

//     // Only return <body> content (avoid <html>, <head>, <style> leaks)
//     return doc.body.innerHTML;
//   } catch (e) {
//     return "<div>Error parsing content</div>";
//   }
// };

const UserCollectionDetails = () => {
  const { id } = useParams();

  const [filters, setFilters] = useState({
    limit: 1, // paginating 1 page at a time
    page: 1,
    sortQuery: "ordering",
  });

  const { data, error, isLoading, isFetching } = useFetch({
    dependencies: ["userCollectionPages", filters, id],
    fetchFunction: async () => {
      if (!id) return;
      const res = await userCollectionPagesList({
        collectionId: id,
        ...filters,
      });
      return res?.docs;
    },
  });

  const totalDocs = data?.metadata?.totalDocs || 1;
  const totalPages = Math.ceil(totalDocs / filters.limit);

  const handlePageChange = (direction) => {
    setFilters((prev) => ({
      ...prev,
      page:
        direction === "next"
          ? Math.min(prev.page + 1, totalPages)
          : Math.max(prev.page - 1, 1),
    }));
  };

  return (
    <div className="w-full h-screen relative bg-black text-white overflow-hidden">
      {isLoading || isFetching ? (
        <div className="text-center py-20 text-xl">Loading...</div>
      ) : error ? (
        <div className="text-red-500 text-center py-20">
          Error loading data.
        </div>
      ) : (
        <>
          <Swiper
            pagination={{ clickable: true }}
            modules={[Pagination]}
            style={{ height: "100vh" }}
          >
            {data?.data?.map((item) => (
              <SwiperSlide key={item._id}>
                <div className="w-full h-full">
                  <iframe
                    title={`page-${item._id}`}
                    srcDoc={item.content}
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "2px solid black",
                    }}
                    sandbox="allow-scripts allow-same-origin"
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>

          {/* Pagination Controls */}
          <div className="absolute bottom-4 left-0 right-0 flex justify-between px-6 z-50">
            <button
              onClick={() => handlePageChange("prev")}
              disabled={filters.page <= 1}
              className="bg-white text-black px-4 py-2 rounded disabled:opacity-50"
            >
              Previous
            </button>
            <span className="text-white">{`Page ${filters.page} of ${totalPages}`}</span>
            <button
              onClick={() => handlePageChange("next")}
              disabled={filters.page >= totalPages}
              className="bg-white text-black px-4 py-2 rounded disabled:opacity-50"
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default UserCollectionDetails;
